import appConfig from "constants/appConfig";

import { isAllowedByEmail } from "./functions/isAllowedByEmail";
import { isAllowedByEventId } from "./functions/isAllowedByEventId";
import { isAllowedByFeatureName } from "./functions/isAllowedByFeatureName";
import { isDisallowedByFeatureName } from "./functions/isDisallowedByFeatureName";
import { OptionSchema } from "./schemas/optionSchema";

import type { Options } from "./types/options";

type IsFeatureEnabled = (options: Options) => boolean;

/**
 * @description
 * 特定の条件下のみで機能を公開するために使用する関数
 * option の増減に伴い処理を変える必要をなくすため、 zod でわざと取り得る情報を最大にしてる
 * 以下の理由から処理そのものもは本関数が取り得る最大値としている
 * - option は利用箇所や featureName の値に依存した定義を特定するため
 * - 処理は option に依存しない最大限の処理
 * @param options {@link Options}
 */
export const isFeatureEnabled: IsFeatureEnabled = (options) => {
  const parsedResult = OptionSchema.safeParse(options);
  if (!parsedResult.success) return false;

  const {
    data: { email, eventId, featureName, isEnabledAtDevelopment },
  } = parsedResult;

  if (isDisallowedByFeatureName(featureName)) return false;

  if (isEnabledAtDevelopment === true && !appConfig.isProd) return true;

  if (email !== undefined && isAllowedByEmail(email)) return true;

  if (eventId !== undefined && isAllowedByEventId(eventId, featureName))
    return true;

  return isAllowedByFeatureName(featureName);
};
